import React from 'react';
import useNodeWithAbsolutePosition from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/hooks/use-node-with-absolute-position';
import DeleteIcon from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/components/delete-icon';
import LinkIcon from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/components/link-icon';
import CopyIcon from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/components/copy-icon';
import CutIcon from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/components/cut-icon';
import { NodeContextMenuProps } from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/index';
import { SurfaceNodeUnion } from 'graphql/types';
import useCurrentSurfacePermissions from 'components/canvas/hooks/use-current-surface-permissions';
import SurfaceNodeRiskIcon from 'components/canvas/components/nodes/components/surface-node/components/surface-node-risk-icon';
import { useRiskMenuPosition } from 'state/canvas/selected-risk';

export interface IconsProps {
  node: SurfaceNodeUnion;
  icons: {
    delete: React.ReactElement | null;
    copy: React.ReactElement | null;
    cut: React.ReactElement | null;
    link: React.ReactElement | null;
  };
}

export default function useNodeContextMenuIcons(props: NodeContextMenuProps) {
  const [riskPos, setRiskMenuPosition] = useRiskMenuPosition();

  function showRisk(event_) {
    const stage = event_.target.getStage();
    const pointerPosition = stage.getPointerPosition();
    const offset = { x: event_.target.attrs.x, y: event_.target.attrs.y };

    const imageClickX = pointerPosition.x + 30; // + offset.x;
    const imageClickY = pointerPosition.y - offset.y;

    console.table({ x: imageClickX, y: imageClickY });

    console.table({ ...event_.target });
    console.log('showRisk ', node.position);
    setRiskMenuPosition({ x: imageClickX, y: imageClickY });
  }

  const node = useNodeWithAbsolutePosition(props.node);

  const {
    canLinkSurfaceNode,
    canCutSurfaceNode,
    canCopySurfaceNode,
    canDeleteSurfaceNode,
    canDeleteOwnedSurfaceNode,
  } = useCurrentSurfacePermissions();

  const canDelete =
    canDeleteSurfaceNode() || canDeleteOwnedSurfaceNode(props.node);

  const icons = {
    link: canLinkSurfaceNode() ? <LinkIcon node={node} /> : null,
    copy: canCopySurfaceNode() ? <CopyIcon node={node} /> : null,
    cut: canCutSurfaceNode(props.node) ? <CutIcon node={node} /> : null,
    delete: canDelete ? (
      <DeleteIcon
        node={node}
        onAfterDelete={props.onAfterDelete}
        hardDelete={props.hardDelete}
      />
    ) : null,

    risk:
      props.node.__typename != 'SubSurfaceNode' ? (
        <SurfaceNodeRiskIcon onClick={showRisk} />
      ) : null,
  };

  if (props.icons) {
    return props.icons({ node, icons });
  }

  return [
    ...(props.prePendIcons ?? ([] as any)),
    ...Object.values(icons).filter(Boolean),
  ];
}
